import React, { Component } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { LoadingIndicator, Button } from '../../components';
import ThemeColors from '../../theme/colors';
import SeachResults from './search-results-tiles';
import SwipeableViews from 'react-swipeable-views';
import SearchResultsCards from './search-result-tiles-cards';
import SearchBar from './search-bar';
import queryString from 'query-string';
import LearningContent from '../course/learning-content';
import Dialog from '../dialogs/dialog/dialog';

class SearchResults extends Component {

  constructor(props) {
    super(props);

    this.state = {
      searchTerm: '',
      slideIndex: 0,
    };

    this.search = this.search.bind(this);
  }

  componentWillMount() {
    const searchTerm = queryString.parse(this.props.location.search).searchTerm;
    if (searchTerm) {
      this.setState({
        searchTerm: queryString.parse(this.props.location.search).searchTerm,
      }, () => {
        this.props.search(this.state.searchTerm);
      });
    }
  }

  handleChange = (event, value) => {
    this.setState({
      slideIndex: value,
    });
  };

  search(searchTerm) {
    this.props.history.push(`search?searchTerm=${searchTerm}`);
    this.setState({
      searchTerm,
    });
    this.props.search(searchTerm);
  }

  loadCourse(course) {
    this.props.loadCourse(course);
    this.props.history.push(`courses/${course.id}`);
  }

  loadTest(test) {
    this.props.loadTest(test);
    this.props.history.push(`tests/${test.id}`);
  }

  loadCard(card) {
    this.props.loadCourse({ id: card.parentId });
    this.props.history.push(`courses/${card.parentId}?cardId=${card.context.id}`);
  }

  loadQuestion(question) {
    this.props.loadTest({ id: question.parentId });
    this.props.history.push(`tests/${question.parentId}?questionId=${question.context.id}`);
  }

  getCourseResults() {
    return this.props.results.filter(r => r.type === 'course').map(r => r.context);
  }

  renderCourseResultView() {
    const courseResults = this.getCourseResults();
    return (
      <SeachResults
        type={'Kurse'}
        items={courseResults}
        onClick={this.loadCourse.bind(this)}
      />
    );
  }

  getTestResults() {
    return this.props.results.filter(r => r.type === 'test').map(r => r.context);
  }

  renderTestResultView() {
    const testResults = this.getTestResults();
    return (
      <SeachResults
        type={'Tests'}
        items={testResults}
        onClick={this.loadTest.bind(this)}
      />
    );
  }

  getCardResults() {
    return this.props.results.filter(r => r.type === 'card');
  }

  renderCardResultModal() {
    if (!this.props.card) return null;

    const dialogOption = (
      <Button
        label="Schließen"
        primary1Color
        onClick={() => this.setState({ showCardResultModal: false })}
      />

    );

    return (
      <Dialog
        open={this.state.showCardResultModal}
        onRequestClose={() => this.setState({ showCardResultModal: false })}
        actions={dialogOption}
      >
        <LearningContent
          content={this.props.card}
          key={this.props.card.id}
        />
      </Dialog>
    );
  }

  renderCardResultsView() {
    const cards = this.getCardResults();
    return (
      <SearchResultsCards
        type={'Kärtchen'}
        items={cards}
        onClick={this.loadCard.bind(this)}
        searchTerm={this.state.searchTerm}
      />
    );
  }

  getQuestionResults() {
    return this.props.results.filter(r => r.type === 'question');
  }

  renderQuestionResultsView() {
    const questions = this.getQuestionResults();
    return (
      <SearchResultsCards
        type={'Fragen'}
        items={questions}
        onClick={this.loadQuestion.bind(this)}
        searchTerm={this.state.searchTerm}
      />
    );
  }

  // handleChange = (value) => {
  //   this.setState({
  //     slideIndex: value,
  //   });
  // };

  renderContent() {
    if (this.props.loading) {
      return <LoadingIndicator show centered />;
    }

    const tabStyle = {
      background: 'white',
    };

    const tabStyleActive = {
      background: 'white',
      borderBottomColor: ThemeColors.primary1Color,
      borderBottomWidth: 3,
      borderBottomStyle: 'solid',
    };

    const tabBarStyle = {
      width: 300,
      margin: '0 auto',
      marginTop: 20,
    };

    // const tabLabels = ['Kurse', 'Kärtchen', 'Tests', 'Fragen'];
    // const tabItems = tabLabels.map((tab, index) => {
    //   return <Tab buttonStyle={this.state.slideIndex == index ? tabStyleActive : tabStyle} label={tab} value={index} />
    // });

    const tabLabels = ['Kurse', 'Kärtchen', 'Tests', 'Fragen'];
    const tabItems = tabLabels.map((tab, index) => <Tab
      disableRipple
      buttonStyle={this.state.slideIndex === index ? tabStyleActive : tabStyle}
      label={tab} value={index}
    />);

    return (
      <div>
        <Tabs
          indicatorColor="primary"
          variant="fullWidth"
          textColor="primary"
              // style={tabBarStyle}
          onChange={this.handleChange}
          value={this.state.slideIndex}
        >
          {tabItems}
        </Tabs>
        <SwipeableViews
          index={this.state.slideIndex}
          onChangeIndex={this.handleChange}
        >
          {this.renderCourseResultView()}
          {this.renderCardResultsView()}
          {this.renderTestResultView()}
          {this.renderQuestionResultsView()}
        </SwipeableViews>
      </div>
    );
  }

  render() {
    return (
      <div className="col-lg-12 col-md-12 col-sm-12">
        <SearchBar location={this.props.location} onSearch={this.search} />
        {this.renderContent()}

      </div>
    );
  }
}

export default SearchResults;



// WEBPACK FOOTER //
// ./src/app/main/search/search-results.js